<template>
  <div class="" v-if="!check">
    <div class="">
      <div class="registration-head text-center" :style="styleHeader">
        <div class="sml-container">
          <div class="rg-head">
            <h1>キャリア登録フォーム</h1>
          </div>
        </div>
      </div>
      <div class="sml-container">
        <div class="rgst-sec">
          <div class="career-rgst">
            <img src="../assets/NewLogo.svg" />
          </div>
          <div class="mt-5 ml-auto mr-auto" style="width:100%">
            <h5>ご自身の情報を入力してください</h5>
          </div>
          <div class="rgst-dtl-sec mt-5">
            <BRegistration :endpointKey="'bloomValidate'" @redirectToPreviewPage="redirectToPreview"/>
          </div>
          <!-- ends rgst-dtl-sec -->
        </div>
        <!-- ends rgst-sec -->
      </div>
    </div>
    <!-- ends main-area -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BRegistration from "./BRegistration.vue";
export default {
  name: "BloomRegistration",
  components: { BRegistration },
  data() {
    return {
      check: true
    }
  },
  computed: {
    styleHeader() {
      return { background: "#006C6B" };
    },
  },
  methods: {
    ...mapActions({
      setBloomData: "setBloomData",
      checkMaintenance: "checkMaintenance",
    }),
    redirectToPreview(){
      this.$router.push({name: 'preview2'})
    },
    scrollToTop() {
      const element = document.getElementsByClassName("main-wrapper")[0];
      if (element) {
        element.scrollIntoView();
        // console.log(parent.offsetTop - (parent.offsetHeight * 2));
        // console.log(parent.offsetTop);
        // console.log(document.getElementsByClassName('form-detail')[0]);
        // document.getElementsByClassName('form-detail')[0].scrollTop =
        // parent.offsetTop - (parent.offsetHeight * 2);
      }
    },
  },
  async mounted() {
    this.scrollToTop();
    await this.setBloomData(true);
  },
  async created() {
    const check = await this.checkMaintenance();
    this.check = check;
    if (check) this.$router.push({ name: "Maintenance" });
  },
};
</script>

<style scoped>
h5 {
  text-align: center !important;
  font-size: 23px;
}
</style>
